import './WPlayerQueueList.js';
import '@/components/reusable/RMenuButton';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    r-menu-button {
    --size: 36px;
  }
`);
export class WPlayerQueue extends HTMLElement {
    static tag = 'w-player-queue';
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [styleSheet];
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <r-menu-button class="toggler"></r-menu-button>
    `;
        this.#processTogglerClick();
    }
    /** @param {Playlist} v  */
    set playlist(v) {
        this.shadowRoot.querySelector('w-player-queue-list').playlist = v;
    }
    /** @type {WPlayerQueueList} */
    #queueList = this.#createQueueList();
    #createQueueList() {
        const $queueList = /** @type {WPlayerQueueList} */ document.createElement('w-player-queue-list');
        document.body.append($queueList);
        return $queueList;
    }
    #processTogglerClick() {
        this.shadowRoot.querySelector('.toggler').addEventListener('click', () => {
            if (this.#queueList.isOpened)
                return this.#queueList.close();
            this.#queueList.open();
        });
    }
}
customElements.define(WPlayerQueue.tag, WPlayerQueue);
